//import packages from node modules
import React from 'react'
import PropTypes from 'prop-types'

//import utilities functions
import {
    ADD_DOMAIN_PAGE,
    EDIT_DOMAIN_PAGE,
    LOCALE_STRING_OPTIONS
} from "../../../../utilities/function/common"

import {
    getProductLabel,
    getOrderingFlowType
} from "../../../../utilities/function/configuration"

import {
    getCycle
} from "../../../../utilities/function/billingCycle"

import {
    getPageByURL
} from "../../../../utilities/function/urlparams"

import {CUSTOM_HOSTING_FLOW} from "../../../../utilities/function/productFlow"
import {getIconSlugBasedOnServiceType} from "../../../../utilities/function/manageServiceTypes"

//import shared components
import Checkbox from "../../form/checkbox"
import {SHARED_HOSTING_TYPE} from "../../../../utilities/function/servicetype";

//import internals

//main component
const DomainConfigUpsell = ({location,domainConfigContext,item,configurations,getInputName} ) => {
    const {state} = domainConfigContext
    const getHostingByDomainName = (domainname) => {
        let hosting = null
        if (configurations && Object.keys(configurations).length > 0) {
            Object.keys(configurations).forEach(key => {
                if (configurations[key]) {
                    const {name, uuid, selectedProduct} = configurations[key]
                    if (uuid && name === domainname && selectedProduct && selectedProduct.attributes) {
                        const {service_type} = selectedProduct.attributes
                        if (service_type === SHARED_HOSTING_TYPE) {
                            hosting = configurations[key]
                        }
                    }
                }
            })
        }
        return hosting
    }
    if (state) {
        const {
            requestUpsellStatus,
            requestUpsellData
        } = state
        if (requestUpsellStatus === 'success' && requestUpsellData) {
            const page_type = getPageByURL(location.search)
            if (page_type === ADD_DOMAIN_PAGE || page_type === EDIT_DOMAIN_PAGE) {
                let domainname = null
                if (page_type === ADD_DOMAIN_PAGE) {
                    if (item && item.domainSearchResult) {
                        const {domain, tld} = item.domainSearchResult
                        domainname = domain + tld
                    }
                } else if (page_type === EDIT_DOMAIN_PAGE) {
                    domainname = item.name
                }
                if (domainname) {
                    const hosting = getHostingByDomainName(domainname)
                    if (hosting) {
                        return (
                            <div className={'of-domain-upsell status-background-1-100'}>
                                <div className={'of-domain-upsell__wrapper'}>
                                    Has Hosting
                                </div>
                            </div>
                        )
                    } else {
                        const generateOptions = () => {
                            let list = []
                            if (requestUpsellData && requestUpsellData.length > 0) {
                                requestUpsellData.forEach((item) => {
                                    const {id} = item
                                    if (item && item.attributes) {
                                        const {name, description, price, service_type,config_options} = item.attributes
                                        let selectedPrice = null
                                        let label = getProductLabel(name,service_type)
                                        if (price && Array.isArray(price) && price.length > 0) {
                                            selectedPrice = price[0]
                                        }

                                        const orderingFlow = getOrderingFlowType(id)
                                        if(orderingFlow===CUSTOM_HOSTING_FLOW){
                                            let {upsell} = window.app_config
                                            try {
                                                const upsellJSON = JSON.parse(`[${upsell}]`)
                                                if(upsellJSON && Array.isArray(upsellJSON)){
                                                    const selectedUpsell = upsellJSON.find(upsell=>upsell.id=== id)
                                                    if(selectedUpsell){
                                                        if(config_options && Array.isArray(config_options)){
                                                            selectedPrice.price = 0
                                                            config_options.forEach(item=>{
                                                                const {id,options} = item
                                                                const selectedConfig = selectedUpsell.config.find(config=>id===config.config_id)
                                                                if(selectedConfig){
                                                                    const selectedOption = options.find(option=>option.id===selectedConfig.option_id)
                                                                    if(selectedOption && selectedOption.price && selectedOption.price.length){
                                                                        selectedPrice.price += parseFloat(selectedOption.price[0].price)
                                                                    }
                                                                }
                                                            })
                                                            if(selectedPrice.price){
                                                                selectedPrice.price = selectedPrice.price.toLocaleString(undefined,LOCALE_STRING_OPTIONS)
                                                            }
                                                        }
                                                        if(selectedUpsell && selectedUpsell.preset_name){
                                                            label = selectedUpsell.preset_name
                                                        }
                                                    }
                                                }
                                            }catch (e) {console.log(e)}
                                        }

                                        const config = {
                                            selectedProduct: item
                                        }

                                        list.push({
                                            label,
                                            description: description,
                                            price: selectedPrice ? selectedPrice.price : '',
                                            cycle: selectedPrice ? getCycle(selectedPrice.name) : '',
                                            key: id,
                                            value: id,
                                            initialValues: null,
                                            icon: `of-${getIconSlugBasedOnServiceType(config)}`
                                        })
                                    }
                                })
                            }
                            return list
                        }
                        return (<Checkbox
                            className='lines-border-1-100 of-domain-config__upsell of-select-additional-options__checkbox'
                            name={getInputName('Upsells')} data={generateOptions()}/>)
                    }
                }
            }
        }
    }
    return (<></>)
}

DomainConfigUpsell.propTypes = {
    location: PropTypes.object,
    domainConfigContext: PropTypes.object,
    item: PropTypes.object,
    configurations: PropTypes.object,
    getInputName: PropTypes.func
}

export default DomainConfigUpsell
